import { render, staticRenderFns } from "./PartnerCreate.vue?vue&type=template&id=dc67d39c&scoped=true&"
import script from "./PartnerCreate.vue?vue&type=script&lang=js&"
export * from "./PartnerCreate.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCreate.vue?vue&type=style&index=0&id=dc67d39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc67d39c",
  null
  
)

export default component.exports